<mat-dialog-content>
    <ng-container *ngIf="!schedulerClassValue">
        <div class="assigned-sales-rep">
            <app-avatar-block [isLoadingInitialData]="!data.assignedSalesRep"
                              [iconImage]="data.assignedSalesRep.profileImage"
                              [initials]="data.assignedSalesRep.initials"
                              [wrappedText]="true">
                <span avatarTitle>{{ 'Welcome to PayHOA!' }}
                    <ng-container *ngIf="showAssignedSalesRep">
                        <br />
                        {{ 'I\'m ' + firstName + ', your dedicated Onboarding Specialist.' }}
                    </ng-container>
                </span>
                <span avatarDescription>
                    {{ (showAssignedSalesRep ? 'I' : 'We') + ' would love to learn more about your community and to give you a one-on-one tour of PayHOA. Please select an option below, and let\'s get started!' }}
                </span>
            </app-avatar-block>
        </div>

        <div class="card animated animated-delay fadeInTop">
            <button class="btn text-left add-hover" [disabled]="!data.assignedSalesRep" (click)="scheduleDemo()">
                <app-avatar-block [isLoadingInitialData]="!data.assignedSalesRep" [icon]="'model_training'" [wrappedText]="true">
                    <span avatarTitle>{{ 'Personal Walkthrough/Demo and Training' }}</span>
                    <span avatarDescription>{{ 'This 45-minute meeting will provide a detailed tour of the PayHOA platform and we\'ll go over best practices for managing your community in PayHOA.' }}</span>
                </app-avatar-block>
            </button>
        </div>

        <div class="card animated animated-delay fadeInTop">
            <button class="btn text-left add-hover" [disabled]="!data.assignedSalesRep" (click)="scheduleDemo(true)">
                <app-avatar-block [isLoadingInitialData]="!data.assignedSalesRep" [icon]="'forum'" [wrappedText]="true">
                    <span avatarTitle>{{ 'Q&A Session' }}</span>
                    <span avatarDescription>{{ 'This 30-minute meeting is ideal for Admins who do not need a full product walkthrough but may have specific questions and/or want to work on getting their account set up.' }}</span>
                </app-avatar-block>
            </button>
        </div>
    </ng-container>

    <div id="scheduler" [hidden]="!schedulerClassValue"></div>
</mat-dialog-content>

<img class="mat-close" src="/assets/images/payhoa/other/icon_close.svg" mat-dialog-close>
